// extracted by mini-css-extract-plugin
module.exports = {"container":"MultipleAnswers_container__1Lue5","stem":"MultipleAnswers_stem__3wjMe"};